import { render, staticRenderFns } from "./DispositivosSeriadosDetalles.vue?vue&type=template&id=22dd6b0e&"
import script from "./DispositivosSeriadosDetalles.vue?vue&type=script&lang=ts&"
export * from "./DispositivosSeriadosDetalles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22dd6b0e', component.options)
    } else {
      api.reload('22dd6b0e', component.options)
    }
    module.hot.accept("./DispositivosSeriadosDetalles.vue?vue&type=template&id=22dd6b0e&", function () {
      api.rerender('22dd6b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RecepcionEquipos/Acciones/DispositivosSeriadosDetalles.vue"
export default component.exports